import React from 'react';
import PillButton from '../PillButton';

export interface ChatComposerChipProps {
    label: string;
    icon?: React.ReactNode;
    /** Sits after the label — a caret on a chip that opens a menu. */
    trailingIcon?: React.ReactNode;
    /** Makes the chip a control. Without it, the chip reports rather than acts. */
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
}

/**
 * One item in the row under a composer — a clear action, a model picker, a meter.
 *
 * A `PillButton` in `tab` shape: the row hangs off the bottom edge of the field, so the tops
 * are square and the whole row reads as attached to it rather than floating beneath it.
 */
const ChatComposerChip: React.FC<ChatComposerChipProps> = ({
    label,
    icon,
    trailingIcon,
    onClick,
    disabled = false,
    className = '',
}) => (
    <PillButton
        label={label}
        icon={icon}
        trailingIcon={trailingIcon}
        shape="tab"
        size="small"
        interactive={Boolean(onClick)}
        disabled={disabled}
        onClick={onClick}
        className={className}
    />
);

export default ChatComposerChip;
export { ChatComposerChip };
